import React, {Component} from "react";
import {connect} from "react-redux";
import {NavLink, withRouter} from "react-router-dom"

import Constants from "../../../constants/constants.js";

import "./sidebar.css";

class Sidebar extends Component {
    render() {
        const {currentUserOrganization, currentUserId, isSuperRole, token, user} = this.props;

        const roleLevel = user.roleLevel;
        console.log(`   ~~~ Sidebar roleLevel ${roleLevel}.`)
        let sidebarNavItems;
        if (roleLevel === Constants.ORGANIZATION_ADMIN_ROLE_LEVEL/* ORGANIZATION ADMIN */ ) {
            sidebarNavItems = navItems(isSuperRole, currentUserId, currentUserOrganization, true, user.limited);
        }
        else if (roleLevel === Constants.THERAPIST_ROLE_LEVEL || roleLevel === Constants.ADMIN_ROLE_LEVEL) {
            sidebarNavItems = navItems(isSuperRole, currentUserId, currentUserOrganization, false, user.limited);
        }
        else if (roleLevel === Constants.PLAYER_ROLE_LEVEL) {
            sidebarNavItems = homePlayerNavItems();
        }
        else if (roleLevel === Constants.CARE_PARTNER_ROLE_LEVEL){
            sidebarNavItems = carePartnerNavItems(currentUserId, currentUserOrganization);
        }
        else if (roleLevel === Constants.REGIONAL_ADMIN_ROLE_LEVEL || roleLevel === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL) {
            sidebarNavItems = managerDashboard(currentUserId);
        }
        

        return (
            <div className="text-left container-fluid Sidebar-container">
                <table className="container-fluid">
                    <tbody>
                {
                    sidebarNavItems.map((navItem) => {
                        return (
                            <tr key={navItem.label}>
                                <td>
                                    <NavLink className="py-2 Sidebar-link" activeClassName="active" to={navItem.route}>
                                        <table className="mx-2 px-2">
                                            <tbody>
                                            <tr>
                                                <td className="pl-2"><i className={"fa " + navItem.icon}/></td>
                                                <td className="pl-2">{navItem.label}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </NavLink>
                                </td>
                            </tr>
                        )
                    })
                }
                {
                  isSuperRole && <tr><td><a className="admin-dashboard-button" target="_blank" href={process.env.REACT_APP_API_SERVER + "/admin?token=" +token} rel="noopener noreferrer">Admin Dashboard</a></td></tr>
                }
                    </tbody>
                </table>
            </div>
        );
    }
}


function carePartnerNavItems(currentUserId, currentUserOrganization) {
    const navItems = [
        { label: "Player Search", icon: "fa-search", route: "/care-partner-dashboard"}
    ];

    return navItems;
}

function managerDashboard(currentUserId) {
    const navItems = [
        { label: "Manage", icon: "fa-home", route: "/manager-dashboard"},
        { label: "Stats", icon: "fa-bar-chart", route: "/stats-dashboard"}
    ];

    return navItems;
}

function homePlayerNavItems() {
    const navItems = [
        { label: "Home Play", icon: "fa-home", route: "/home-player-dashboard"}
    ];

    return navItems;
}

function navItems(isSuperRole, currentUserId, currentUserOrganization, isOrganizationAdmin, limited) {
    if (typeof isOrganizationAdmin === "undefined"){
        isOrganizationAdmin = false;
    }

    let navItems = [];
    if (limited) {
        navItems = [
            {label: "Play", icon: "fa-play", route: "/play-screen"},
            {
                label: "My Team", icon: "fa-users",
                route: {
                    pathname: "/teamMembers", isSuperRole: isSuperRole,
                    currentUserOrganization: currentUserOrganization
                }
            }
        ];
    }

    else {
        navItems = [
            {label: "Play", icon: "fa-play", route: "/play-screen"},
            {label: "My Players", icon: "fa-user", route: "/therapistDashboard"},
            // {
            //     label: "My Profile", icon: "fa-user-md",
            //     route: {pathname: `/teamMember/${currentUserId}/`, isCurrentUser: true, title: "My Profile"}
            // },
            {label: "Session Bank", icon: "fa-clipboard", route: "/sessionBank"},
            {
                label: "My Team", icon: "fa-users",
                route: {
                    pathname: "/teamMembers", isSuperRole: isSuperRole,
                    currentUserOrganization: currentUserOrganization
                }
            }
        ];
    }
    

    if (isOrganizationAdmin) {
        //metabase dashboard
        navItems.push({label: "Stats", icon: "fa-bar-chart", route: "/stats-dashboard"});
    }

    if (isSuperRole) {
        navItems.push({label: "Organizations", icon: "fa-building", route: "/organizationForm"})
        navItems.push({label: "Tournaments", icon: "fa-flag-checkered", route:"/tournament"})
    }

    if (!limited) {
        navItems.push({label: "Archive", icon: "fa-archive", route: "/playerArchive"});
    }
    

    return navItems
}


const withState = connect(state => {
    const {user, player, menu} = state;

    return {
        user: user,
        currentUserId: user.currentUserId,
        token: user.token,
        currentUserOrganization: user.currentUserOrganization,
        isSuperRole: user.isSuperRole,
        menu: menu.menu,
        player: player.player
    }
});

export default withRouter(withState(Sidebar));



// WEBPACK FOOTER //
// ./src/components/containers/sidebar/sidebar.js